import React from "react";
import {Link} from "react-router-dom";
import exclamation from "@/assets/images/exclamation.svg";
import useDrmPfInformationSearchHooks from "@/containers/DrmPfInformation/useDrmPfInformationSearchHooks";
import {SearchResultsContainer} from "@/components/DrmPfInformationSearch/SearchResultsContainer";
import {SearchConditionContainer} from "@/components/DrmPfInformationSearch/SearchConditionContainer";
import {useDrmPfInformationFont} from "@/utils/useDrmPfInformationFont";
import {BASE_URL, DRM_BASE_URL, PF_BASE_URL} from "@/config";

export default function DrmPfInformationSearch() {
  const drmPfInformationHooks = useDrmPfInformationSearchHooks();
  useDrmPfInformationFont();
  return (
    <div className="uk-flex uk-flex-column uk-flex-middle">
      <div className="sub-header">
        <p className="uk-text-large uk-text-bold uk-margin-remove">
          お知らせ一覧
        </p>
      </div>
      <div className="uk-width-3-4 uk-margin-top">
        <div className="uk-flex uk-flex-middle uk-flex-between">
          <div  className="uk-flex uk-flex-middle">
            <img src={exclamation} alt=""/>
            <p className="uk-text-medium uk-text-bold uk-margin-small-left">
              お知らせ一覧
            </p>
          </div>
          <a href={DRM_BASE_URL}>DRM 一般財団法人 日本デジタル道路地図協会</a>
        </div>
        <div className="uk-margin-top">
          <ul className="uk-tab attribute-tab">
            <li className="uk-active">
              <Link to="#">検索</Link>
            </li>
            <div className="right uk-flex">
              <p>更新日</p>
              <p className="uk-margin-small-left">{drmPfInformationHooks.lastModified}</p>
            </div>
          </ul>
        </div>

        <div className="uk-margin-large-bottom">
          <SearchConditionContainer drmPfInformationHooks={drmPfInformationHooks}/>
          <SearchResultsContainer drmPfInformationHooks={drmPfInformationHooks}/>
        </div>
      </div>
    </div>
  );
}
